'use client';

import { RenderIcon } from '@components/Button';
import { NavSection } from '@util/shopNav';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC, useEffect, useState } from 'react';
import { Column, Dropdown, Header, NavBorder, SecondarySublinkDownArrow } from './styles';

export interface SecondaryNavBarProps {
  topLevelNav: NavSection[];
  allowedSlugs: string[];
}

const Component: FC<SecondaryNavBarProps> = ({ topLevelNav, allowedSlugs }) => {
  const [secondaryNav, setSecondaryNav] = useState<any | null>(null);

  const pathname = usePathname();

  useEffect(() => {
    if (topLevelNav && pathname && allowedSlugs?.some((s) => pathname.includes(s))) {
      setSecondaryNav(topLevelNav);
    } else {
      setSecondaryNav(null);
    }
  }, [topLevelNav, allowedSlugs, pathname]);

  if (secondaryNav) {
    return (
      <>
        <Header>
          <Column>
            {secondaryNav.map((item) => {
              const text = item.fields.cta.fields.text;

              const url = item.fields.cta.fields.url;
              const subLinks = item.fields.linkList;
              const testId = text?.trim().toLowerCase().split(' ').join('-') + '-test-id';

              return (
                <Dropdown className="hideOnMobile" key={item.sys.id}>
                  <>
                    <Link data-testid={testId} href={url}>
                      {text}
                      {subLinks && (
                        <SecondarySublinkDownArrow>
                          {RenderIcon('ArrowDown', '10px')}
                        </SecondarySublinkDownArrow>
                      )}
                    </Link>
                  </>
                  {typeof subLinks !== 'undefined' && subLinks.length > 0 && (
                    <div className="menu">
                      {subLinks.map((link) => {
                        const text = link.fields.text;
                        const url = link.fields.url;

                        return (
                          <Link data-testid={testId} href={url} key={link.sys.id}>
                            {text}
                          </Link>
                        );
                      })}
                    </div>
                  )}
                </Dropdown>
              );
            })}
          </Column>
        </Header>
        <NavBorder className="hideOnMobile" />
      </>
    );
  } else {
    return null;
  }
};

export default Component;
